"use strict";
var __extends = (this && this.__extends) || (function () {
    var extendStatics = Object.setPrototypeOf ||
        ({ __proto__: [] } instanceof Array && function (d, b) { d.__proto__ = b; }) ||
        function (d, b) { for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p]; };
    return function (d, b) {
        extendStatics(d, b);
        function __() { this.constructor = d; }
        d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
})();
var __assign = (this && this.__assign) || Object.assign || function(t) {
    for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
            t[p] = s[p];
    }
    return t;
};
Object.defineProperty(exports, "__esModule", { value: true });
var React = require("react");
var csod = require("player-core");
var View_1 = require("./View");
var JobDetailsBanner_1 = require("../JobDetailsBanner/JobDetailsBanner");
exports.JobDetailsBanner = JobDetailsBanner_1.JobDetailsBanner;
var player_content_wrapper_1 = require("player-content-wrapper");
exports.ContentWrapper = player_content_wrapper_1.default;
var Panel_1 = require("player-layout-controls/controls/Panel");
exports.LayoutControlsPanel = Panel_1.Panel;
var JobDetailsNavigation_1 = require("../JobDetailsNavigation/JobDetailsNavigation");
exports.JobDetailsNavigation = JobDetailsNavigation_1.JobDetailsNavigation;
var GridLayout_1 = require("player-layout-controls/controls/GridLayout");
exports.LayoutControlsGridLayout = GridLayout_1.GridLayout;
var GridCol_1 = require("player-layout-controls/controls/GridCol");
exports.LayoutControlsGridCol = GridCol_1.GridCol;
var JobDetailsLocations_1 = require("../JobDetailsLocations/JobDetailsLocations");
exports.JobDetailsLocations = JobDetailsLocations_1.JobDetailsLocations;
var JobDetailsAd_1 = require("../JobDetailsAd/JobDetailsAd");
exports.JobDetailsAd = JobDetailsAd_1.JobDetailsAd;
var JobDetailsMapForDesktop_1 = require("../JobDetailsMapForDesktop/JobDetailsMapForDesktop");
exports.JobDetailsMapForDesktop = JobDetailsMapForDesktop_1.JobDetailsMapForDesktop;
var Text_1 = require("player-common-controls/controls/Text");
exports.CommonControlsText = Text_1.Text;
var JobDetailsMapForMobile_1 = require("../JobDetailsMapForMobile/JobDetailsMapForMobile");
exports.JobDetailsMapForMobile = JobDetailsMapForMobile_1.JobDetailsMapForMobile;
var JobDetails = (function (_super) {
    __extends(JobDetails, _super);
    function JobDetails(props) {
        var _this = _super.call(this, props) || this;
        _this._setState = _this._setState.bind(_this);
        _this._proxyEvent = _this._proxyEvent.bind(_this);
        _this.forceRender = _this.forceRender.bind(_this);
        _this.view = View_1.view.call(_this, _this.props);
        _this.state = {
            viewModel: __assign({}, _this.view.state, _this.props),
            isInit: false
        };
        _this._trackers = {};
        if (typeof csod.context.tracking !== 'undefined') {
            var monikerCallback_1 = function (moniker, eventName) {
                var evt = document.createEvent("Event");
                evt.initEvent("player-" + moniker + "-" + eventName, true, false);
                window.dispatchEvent(evt);
            };
            for (var reporter in csod.context.tracking) {
                var _loop_1 = function (moniker) {
                    var events = csod.context.tracking[reporter][moniker];
                    var _loop_2 = function (i, l) {
                        var event_1 = events[i];
                        var monikerKey = moniker + '.' + event_1;
                        if (typeof this_1._trackers[monikerKey] === 'undefined')
                            this_1._trackers[monikerKey] = function () { monikerCallback_1(moniker, event_1); };
                    };
                    for (var i = 0, l = events.length; i < l; i++) {
                        _loop_2(i, l);
                    }
                };
                var this_1 = this;
                for (var moniker in csod.context.tracking[reporter]) {
                    _loop_1(moniker);
                }
            }
        }
        return _this;
    }
    JobDetails.prototype.componentDidMount = function () {
        var _this = this;
        this.view.initialize
            ? this.view.initialize(this.props)
                .then(function () {
                _this.view.mounted ? _this.view.mounted() : null;
                _this.setState({
                    isInit: true,
                    viewModel: __assign({}, _this.view.state, _this.props)
                });
            })
            : null;
    };
    JobDetails.prototype.componentWillReceiveProps = function (props) {
        var _this = this;
        this.view.receivedProps
            ? this.view.receivedProps(props).then(function () { return _this._setState(_this.state.viewModel, _this.view.state, props); })
            : this._setState(this.state.viewModel, this.view.state, props);
    };
    JobDetails.prototype.componentWillUnmount = function () {
        this.view.unmount ? this.view.unmount() : null;
    };
    JobDetails.prototype.forceRender = function (cb) {
        this.setState({
            viewModel: __assign({}, this.state.viewModel, this.view.state, this.props)
        }, cb ? cb : function () { });
    };
    JobDetails.prototype._setState = function (viewModel, viewState, props) {
        this.setState({ viewModel: __assign({}, viewModel, viewState, props) });
    };
    JobDetails.prototype._proxyTrackEvent = function (moniker, eventID, eventName) {
        var params = [];
        for (var _i = 3; _i < arguments.length; _i++) {
            params[_i - 3] = arguments[_i];
        }
        var args = [];
        for (var i = 3; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        var monikerKey = moniker + '.' + eventID;
        var monikerCallback = this._trackers[monikerKey] || function () { };
        return this._procesEvent(eventName, args, 4, monikerCallback);
    };
    JobDetails.prototype._proxyEvent = function (eventName) {
        var params = [];
        for (var _i = 1; _i < arguments.length; _i++) {
            params[_i - 1] = arguments[_i];
        }
        var args = [];
        for (var i = 1; i < arguments.length; i++) {
            args.push(arguments[i]);
        }
        return this._procesEvent(eventName, args, 2, function () { });
    };
    JobDetails.prototype._procesEvent = function (eventName, args, repeaterArgIndex, callback) {
        args = pushAndShiftArgs(args, repeaterArgIndex);
        if (typeof this.view.events[eventName] === 'function') {
            var self_1 = this;
            return function proxy() {
                var combinedArgs = [].slice.call(arguments).concat(args);
                var shouldRender = self_1.view.events[eventName].apply(self_1, combinedArgs);
                if (shouldRender !== false) {
                    csod.engine.commit();
                }
                csod.lastEventDate = new Date();
                callback();
            };
        }
        else {
            return function noFunc() {
                if (eventName) {
                    csod.logger.warn(eventName + ' is not a valid function. Please check for typos.');
                    csod.lastEventDate = new Date();
                }
                callback();
            };
        }
    };
    JobDetails.prototype.render = function () {
        var _this = this;
        var PlayerRepeater = csod.engine.controls.Player.Repeater;
        var PlayerVisible = csod.engine.controls.Player.Visible;
        var PlayerSwitch = csod.engine.controls.Player.Switch;
        var $this = this;
        var root_handler = function () {
            return [React.createElement(PlayerVisible, { key: 0, visible: $this.state.viewModel.isJobAvailableToApply, children: [React.createElement(JobDetailsBanner_1.JobDetailsBanner, { key: 0, backgroundImage: $this.state.viewModel.bannerImagePath, reqId: $this.state.viewModel.jobRef, reqTitle: $this.state.viewModel.title, location: $this.state.viewModel.locationDisplay, applyNowButtonText: $this.state.viewModel.applyNowButtonText, shareBtnText: $this.state.viewModel.shareBtnText, shareOptions: $this.state.viewModel.shareOptions, isApplyNowButtonDisabled: $this.state.viewModel.isApplyNowButtonDisabled, saveJobText: $this.state.viewModel.saveJobText, isSaveJobDisabled: $this.state.viewModel.isSaveJobDisabled, bannerContentHeight: $this.state.viewModel.bannerContentHeight, postedDateLabel: $this.state.viewModel.postedDateLabel, onApplyClick: _this._proxyEvent("onApply"), onSaveClick: _this._proxyEvent("onSave"), onShareClick: _this._proxyEvent("onShare"), setContentHeight: _this._proxyEvent("setBannerContentHeight") })] }), React.createElement(player_content_wrapper_1.default, { key: 1, children: [React.createElement(Panel_1.Panel, { key: 0, paddingTop: "Large", paddingBottom: "Xlarge", children: [React.createElement(JobDetailsNavigation_1.JobDetailsNavigation, { key: 0, backText: $this.state.viewModel.backToSearchResultsText, searchUrl: $this.state.viewModel.searchUrl })] }), React.createElement(PlayerSwitch, { key: 1, value: $this.state.viewModel.isJobAvailableToApply, true: [React.createElement(PlayerVisible, { key: 0, visible: $this.state.viewModel.hasAdditionalLocations, children: [React.createElement(Panel_1.Panel, { key: 0, paddingBottom: "Medium", children: [React.createElement(GridLayout_1.GridLayout, { key: 0, colsWidth: "12", colsWidthForMd: "8", children: [React.createElement(GridCol_1.GridCol, { key: 0, children: [React.createElement(JobDetailsLocations_1.JobDetailsLocations, { key: 0, locations: $this.state.viewModel.allLocations })] })] })] })] }), React.createElement(Panel_1.Panel, { key: 1, paddingTop: "Xsmall", children: [React.createElement(GridLayout_1.GridLayout, { key: 0, gutterHorizontal: "Medium", gutterVertical: "Small", children: [React.createElement(GridCol_1.GridCol, { key: 0, width: "12", children: [React.createElement(JobDetailsAd_1.JobDetailsAd, { key: 0, html: $this.state.viewModel.jobAd, shareOptions: $this.state.viewModel.shareOptions, applyNowButtonText: $this.state.viewModel.applyNowButtonText, isApplyNowButtonDisabled: $this.state.viewModel.isApplyNowButtonDisabled, saveJobText: $this.state.viewModel.saveJobText, isSaveJobDisabled: $this.state.viewModel.isSaveJobDisabled, onApply: _this._proxyEvent("onApply"), onSave: _this._proxyEvent("onSave"), onShare: _this._proxyEvent("onShare") })] }), React.createElement(GridCol_1.GridCol, { key: 1, isVisible: false, children: [React.createElement(JobDetailsMapForDesktop_1.JobDetailsMapForDesktop, { key: 0, apiKey: $this.state.viewModel.apiKey, defaultZoom: $this.state.viewModel.defaultZoom, centerLat: $this.state.viewModel.centerLat, centerLng: $this.state.viewModel.centerLng, markers: $this.state.viewModel.markers, infoWindowHeaderColor: $this.state.viewModel.infoWindowHeaderColor, iconSrc: $this.state.viewModel.iconSrc, selectedMarkerIconSrc: $this.state.viewModel.selectedMarkerIconSrc, selectedMarkerId: $this.state.viewModel.selectedMarkerId, loadingText: $this.state.viewModel.loadingText, onInfoWindowClick: _this._proxyEvent("onInfoWindowClick") }), React.createElement(Panel_1.Panel, { key: 1, height: "200px", borderColorAll: "Error", borderWidthAll: "Medium", borderStyleAll: "Dashed", children: [React.createElement(Text_1.Text, { key: 0, text: "Similar Jobs Section" })] })] })] })] })], false: [React.createElement(Panel_1.Panel, { key: 0, paddingBottom: "Xlarge", children: [React.createElement(Text_1.Text, { key: 0, mode: "Paragraph", text: $this.state.viewModel.jobUnavailableText })] })] })] }), React.createElement(PlayerVisible, { key: 2, visible: false, children: [React.createElement(JobDetailsMapForMobile_1.JobDetailsMapForMobile, { key: 0, apiKey: $this.state.viewModel.apiKey, defaultZoom: $this.state.viewModel.defaultZoom, centerLat: $this.state.viewModel.centerLat, centerLng: $this.state.viewModel.centerLng, markers: $this.state.viewModel.markers, infoWindowHeaderColor: $this.state.viewModel.infoWindowHeaderColor, iconSrc: $this.state.viewModel.iconSrc, selectedMarkerIconSrc: $this.state.viewModel.selectedMarkerIconSrc, selectedMarkerId: $this.state.viewModel.selectedMarkerId, loadingText: $this.state.viewModel.loadingText, onInfoWindowClick: _this._proxyEvent("onInfoWindowClick") })] })];
        };
        return (React.createElement("div", { className: "p-view-jobdetails" }, this.state.isInit ? root_handler() : null));
    };
    return JobDetails;
}(React.Component));
JobDetails.defaultProps = {
    jobAd: "", title: "", locationDisplay: "", jobRef: "", apiKey: "", defaultZoom: "", centerLat: "", centerLng: "", markers: "", iconSrc: "", loadingText: "", infoWindowHeaderColor: "", selectedMarkerIconSrc: "", selectedMarkerId: "", initMethod: "", backToSearchResultsText: "", searchUrl: "", allLocations: "", hasAdditionalLocations: "", applyNowButtonText: "", shareBtnText: "", shareOptions: "", isApplyNowButtonDisabled: "", saveJobText: "", isSaveJobDisabled: "", isJobAvailableToApply: "", bannerContentHeight: "", bannerImagePath: "", postedDateLabel: "", onApply: function () { }, onSave: function () { }, onShare: function () { }, onInfoWindowClick: function () { }, setBannerContentHeight: function () { }
};
exports.JobDetails = JobDetails;
function pushAndShiftArgs(args, repeaterArgIndex) {
    if (args[repeaterArgIndex] === 'repeaterArgs') {
        args.push(args.shift());
        args.push(args.shift());
        args.shift();
        pushAndShiftArgs(args, repeaterArgIndex);
    }
    return args;
}
if (!window["__LOCALES__"])
    window["__LOCALES__"] = {};
window["__LOCALES__"]["JobDetails"] = [];



//////////////////
// WEBPACK FOOTER
// C:/TeamCity/buildAgent/work/4d5b8a78b9bd1a6f/src/.tmp/JobDetails/JobDetails.js
// module id = 782
// module chunks = 0